import { LoaderFunctionArgs } from 'react-router';
import { fetchTechnicalCard } from '../TechnicalCardsPage/services';

export const technicalCardPageLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const id = String(params.id);

  if (id === 'new') {
    return { data: null };
  }

  try {
    const data = await fetchTechnicalCard({ id });
    return { data };
  } catch (error) {
    return { data: null };
  }
};
